<div class="massive-services-container">
  <div class="header">
    <button class="btn-back" (click)="goBack()">← Volver</button>
    <h1>Altas masivas relación 1-N</h1>
  </div>

  <div class="content">
    <div class="description-box">
      <p>Con esta herramienta puedes realizar altas masivas de relación 1-N cargando un fichero Excel con los ítems a procesar.</p>
    </div>

    <div class="info-box">
      <strong>⚠ Importante:</strong> El fichero Excel debe contener obligatoriamente las <strong>referencias catastrales</strong> de los ítems que se quieran procesar.
    </div>

    <!-- Order Request ID -->
    <div class="form-section">
      <label class="form-label">ID de solicitud de orden <span class="required">*</span></label>
      <input
        type="text"
        class="form-input form-input-full"
        [(ngModel)]="orderRequestId"
        placeholder="Introduce el ID de solicitud de orden..."
      />
    </div>

    <!-- Excel File Selection -->
    <div class="form-section">
      <label class="form-label">Fichero Excel <span class="required">*</span></label>
      <div class="input-group">
        <input
          type="text"
          class="form-input"
          [value]="excelFilePath()"
          readonly
          placeholder="Selecciona un fichero Excel (.xlsx, .xls)..."
        />
        <button class="btn-browse" (click)="selectExcelFile()">Examinar</button>
        <button class="btn-download" (click)="downloadExampleExcel()" title="Descargar Excel de ejemplo">
          ⬇ Ejemplo
        </button>
      </div>
    </div>

    <!-- Portfolio ID (optional) -->
    <div class="form-section">
      <label class="form-label">ID de cartera <span class="optional">(Opcional)</span></label>
      <input
        type="text"
        class="form-input form-input-full"
        [(ngModel)]="portfolioId"
        placeholder="Introduce el ID de cartera (opcional)..."
      />
    </div>

    <!-- Process Manager ID (optional) -->
    <div class="form-section">
      <label class="form-label">ID del gestor del proceso <span class="optional">(Opcional)</span></label>
      <input
        type="text"
        class="form-input form-input-full"
        [(ngModel)]="processManagerId"
        placeholder="Introduce el ID del gestor del proceso (opcional)..."
      />
    </div>

    <!-- Force Launch to Exchange -->
    <div class="form-section">
      <label class="form-label">Bolsa</label>
      <div class="options-group">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="forceLaunchToExchange" />
          <span>Forzar lanzamiento a bolsa</span>
        </label>
      </div>
    </div>

    <!-- Error Message -->
    @if (errorMessage()) {
      <div class="error-box">
        <strong>Error:</strong> {{ errorMessage() }}
      </div>
    }

    <!-- Success Message -->
    @if (successMessage()) {
      <div class="success-box">
        <strong>Éxito:</strong> {{ successMessage() }}
      </div>
    }

    <!-- Submit Button -->
    <div class="button-container">
      <button
        class="btn-submit"
        [disabled]="!canSend()"
        (click)="sendRequest()">
        @if (isSending()) {
          Enviando...
        } @else {
          Enviar
        }
      </button>
    </div>
  </div>
</div>
